<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            添加冻结车辆
          </v-card-title>
          <v-form class="pa-2">
            <v-layout>
              <v-flex xs6>
                <l-plate-picker
                v-model="form.plateNumber"></l-plate-picker>
              </v-flex>
              <v-flex xs3 class="mt-2">
                <v-btn flat color="primary" :disabled="!($rules.plate[0](form.plateNumber)===true)" @click="getDetails">查看车辆详情</v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <l-select-datetime-duration
                v-model="blockDuration"
                label="冻结时段"></l-select-datetime-duration>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-textarea
                  v-model="comment"
                  prepend-icon="$vuetify.icons.comment"
                  rows="1"
                  auto-grow
                  label="冻结说明"></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout justify-center>
            <v-btn class="primary" @click="submit" v-if="enableEdit">提交</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import LPlatePicker from '../../components/LPlatePicker'
import LSelectDatetimeDuration from '../../ladmin/components/LSelectDuration/LSelectDatetimeDuration'
import {time} from '../../ladmin/utils/time'
export default {
  name: 'blackVehicle',
  components: {
    LSelectDatetimeDuration,
    LPlatePicker
  },
  data () {
    return {
      enableEdit: true,
      form: {
        plateNumber: '',
        phone: '',
        registerType: '',
        name: '',
        org: '',
        startDatetime: '',
        endDatetime: ''
      }
    }
  },
  computed: {
    blockDuration: {
      get () {
        return {
          startDatetime: this.form.startDatetime,
          endDatetime: this.form.endDatetime,
        }
      },
      set (val) {
        if (val instanceof Object) {
          this.form.startDatetime = val.startDatetime || ''
          this.form.endDatetime = val.endDatetime || ''
        }
      }
    }
  },
  methods: {
    async submit () {
      // console.log(this.form.endDatetime)
      let searchParam = {
        'fstime': time.toTimeStamp(this.form.startDatetime),
        'fetime': time.toTimeStamp(this.form.endDatetime),
        'objectId': this.form.plateNumber
      }
      let res = await this.$store.dispatch('passControl/addBlackVehicle', {plateNumber: this.form.plateNumber, searchParam: searchParam,comment:this.comment})
      if (res.data.status === 1) {
        this.enableEdit = false
        this.$L.alert('success', {message: '提交成功'})
      }
      else {
        this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
      }
    },
    getDetails () {
      this.$router.push({
        name: 'VehicleStatisticDetails',
        params: {
          plate: this.form.plateNumber,
        },
      })
    }
  }
}
</script>
